import { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import {
  DataGrid,
  GridColDef,
  GridValueGetterParams,
  GridToolbar,
} from "@mui/x-data-grid";
import pdf from "../../assets/PdfIcon.svg";

import AccountsNotifications from "../../stores/AccountsNotificationsStore";
import appointmentStore from "../../stores/AppointmentStore";
import User from "../../stores/UserStore";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import General from "../../stores/GeneralStore";
import { observer } from "mobx-react";
import { DELINK, TabButton } from "../../components/NOC.Tabs/Noc.styled";
import { Spinner } from "../../components/spinner.component";
import { ButtonSecondary } from "../login.screen/login.styled";
import { toJS } from "mobx";
import ReschedulingModal from "../../components/Etoken/etoken/etokenform/ReschedulingModal";
import { NotifySuccess } from "../../utils/ShowSuccess";
import { NotifyError } from "../../utils/ShowError";
import "./etokenForm.scss";
const ManageBooking = (props: any) => {
  const [pageSize, setPageSize] = useState<number>(5);
  const [showTickModal, setShowTickModal] = useState(false);
  const [rescheduleData, setRescheduleData] = useState<any>();
  const [loading, setLoading] = useState(false);

  const [rows, setRows] = useState<Object[]>([]);

  const navigate = useNavigate();


  const loadTable = async () => {
    setLoading(true);
    if(User?.profile?.mobileNumber==null){
      setLoading(true);
      NotifyError(General?.codeLabels['cm_mobilenumberreqerr']?.label);
      return;
    }
    const data={mobile:User?.profile?.mobileNumber? User?.profile?.mobileNumber?.replace(/-/g,''):''}
      // const data={mobile:'0523334444'}
      const res=  await appointmentStore?.getAppointments({errorId:"getappointments",data})
    // await AccountsNotifications.getMyAccounts({
    //   errorId: "getMyAccountsError",
    //   data: User.info.personId as string,
    // });
    if(res?.result?.wsGetApptListResp?.error){
      const errorCode= 'cm_'+res?.result?.wsGetApptListResp?.error?.reason?.toLowerCase()
      NotifyError(General?.codeLabels[errorCode]?.label)
    }
    setRows(appointmentStore?.appointmentList);
    setTimeout(() => {
        setLoading(false)  
    }, 2000);
  };

  useEffect(() => {
    setLoading(true);
    loadTable();
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);
  const handleTickClick = (record:any) => {
    setShowTickModal(true);
    const matchingAppointment = appointmentStore?.apptDetails?.find(
      (appointment) => appointment?.indAppt?.apptCode === record
    );
    setRescheduleData(matchingAppointment);
  };

  const handleCancel = async (record:any) => {
    const matchingAppointment = appointmentStore?.apptDetails?.find(
      (appointment) => appointment?.indAppt?.apptCode === record
    );
    const data = {
      branchCode: matchingAppointment?.indBranch?.branchCode,
      name: matchingAppointment?.cust?.indCust?.name,
      syncId: matchingAppointment?.cust?.indCust?.syncId,
      mobilePhoneNumber: matchingAppointment?.cust?.mobilePhoneNumber,
      apptCode: matchingAppointment?.indAppt?.apptCode,
    };

    try {
      await appointmentStore.cancelAppointment({errorId:"cancelAppointment",data});
      loadTable()
    } catch (error) {
      // Handle any error that occurred during the API call
      console.log(error);
    }
  };

  const columns: GridColDef[] = [

    {
      field: "name",
      headerName: General?.codeLabels['cm_nocname']?.label?General?.codeLabels['cm_nocname']?.label:"Name",
      editable: false,
      flex: 1,
    },
    {
      field: "service",
      headerName:General?.codeLabels['cm_appointmentservicelabel']?.label?General?.codeLabels['cm_appointmentservicelabel']?.label:"Service",
      editable: false,
      flex: 1,
    },
    {
      field: "date",
      headerName: General?.codeLabels['cm_date']?.label?General?.codeLabels['cm_date']?.label:"Date",
      headerAlign: "left",
      editable: false,
      flex: 1,
    },
    {
      field: "time",
      headerName: General?.codeLabels["cm_appointmenttimelabel"]?.label?General?.codeLabels["cm_appointmenttimelabel"]?.label:"Time",
      description: "This column has a value getter and is not sortable.",
      sortable: false,
      flex: 1,
    },
  
 
    {
      field: "Action",
      headerName: General?.codeLabels["cm_action"]?.label?General?.codeLabels["cm_action"]?.label:"Action",
      headerAlign:'center',
      align:'center',
      flex: 1,
      sortable: false,
      renderCell: (params: any) => {
        return (
          <>
          <div style={{display:'flex',justifyContent:'space-between',width:'90%'}}>
          <ButtonSecondary
            style={{
              width:"20px",
              height: "30px",
              fontSize: `${0.8*General.accessibility.fontSize}rem`,
              color: contrast?.contrastBackground?contrast?.contrastBackground:"#fff", background: contrast?.contrastColor?contrast?.contrastColor:'#101E8E',
            }}
            onClick={()=>handleCancel(params?.row.apptcode)}
          >
            {General?.codeLabels["cm_del"]?.label !== undefined ? General?.codeLabels["cm_del"]?.label : "Delete"}
          </ButtonSecondary>
          <ButtonSecondary
            style={{
              width:"30px",
              height: "30px",
              fontSize: `${0.8*General.accessibility.fontSize}rem`,
              color: contrast?.contrastBackground?contrast?.contrastBackground:"#fff", background: contrast?.contrastColor?contrast?.contrastColor:'#101E8E',
            }}
            // onClick={()=>navigate('/dashboard')}
            onClick={()=>handleTickClick(params?.row.apptcode)}
          >
            {General?.codeLabels["cm_reschedule"]?.label !== undefined ? General?.codeLabels["cm_reschedule"]?.label : "Reschedule"}
          </ButtonSecondary>
          </div>
          </>
        );
      },
    },
  ];



  const [isLargeScreen, setIsLargeScreen] = useState(false);

  useEffect(() => {
    function handleResize() {
      setIsLargeScreen(window.innerWidth > 991);
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleReschedule = async (record:any) => {
    const data=record
    try {
      const response = await appointmentStore?.rescheduleAppointment({errorId:"Reschedule",data});
      console.log(response);
      if (response?.statusCode === 200) {
        setShowTickModal(false);
        loadTable()

        if (response.result.wsChangeApptResp.error === null) {
         NotifySuccess("Appointment is rescheduled")
        } else if (response.result.wsChangeApptResp.error.reason) {
          NotifyError('No Slot is available')
        }
      }

      return response;
    } catch (error) {
      // Handle any error that occurred during the API call
      console.log(error);
    }
  };
 
  const ColorAss = General?.ColorAss;
  const contrast = General?.contrast;
  return (
    <div
      style={{
        height: "85vh",
      }}
    >
      <ReschedulingModal
        open={showTickModal}
        onClose={() => setShowTickModal(false)}
        selectedData={rescheduleData}
        handleReschedule={handleReschedule}
        apptDetails={appointmentStore?.apptDetails}
      />

      <Box
        sx={{
          height: "80vh",
          width: props?.MyAccountsWidth ?? "90%",
          background: contrast?.contrastBackground
            ? contrast?.contrastBackground
            : "#fff",
          margin: "auto",
        }}
      >
        <br />
      
        <br />
        {
          loading ? (
            <Spinner />
          ) : (
            <DataGrid
              getRowId={() => Math.floor(Math.random() * 100000000)}
              loading={loading}
              checkboxSelection={false}
              rows={rows}
              hideFooter={true}
              columns={columns}
              disableSelectionOnClick={true}
              // components={{
              //   Toolbar: GridToolbar,
              // }}
              sx={{
                overflow:'auto',
                "& .MuiDataGrid-columnSeparator": { display: "none" ,},
                border: props?.MyAccountsOutline ?? " ",
                color: "#101e8e",
                width:General?.isLargeScreen ?"90%":"100%",
                height: "80%",
                margin: "auto",
                "& .MuiDataGrid-cell, .MuiDataGrid-row": {
                  whiteSpace: "normal !important",
                },

                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : "rgba(229, 239, 242, 0.7)",
                  color: contrast?.contrastBackground
                    ? contrast?.contrastBackground
                    : "",
                  fontSize: `${0.875 * General.accessibility.fontSize}rem`,
                },
                "& .MuiDataGrid-virtualScroller":{
                  overflow:'auto'
                },
                "& .MuiDataGrid-cellContent": {
                  fontSize: `${0.875 * General.accessibility.fontSize}rem`,
                  color: contrast?.contrastColor ? contrast?.contrastColor : "",
                  overflow:'auto'
                },
                "& .MuiSvgIcon-root": {
                  color: contrast?.contrastBackground
                    ? contrast?.contrastBackground
                    : "",
                },
              }}
            />
          )}
      </Box>

      {!isLargeScreen ? <>{/* <AccountsGridMobile/> */}</> : ""}
    </div>
  );
};

export default observer(ManageBooking);
